import NProgress from 'nprogress';
import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import $http from '$http';
import {
    MAP_LIST
} from '$http';

//组件
// import baseInfoForm from 'agent-base-info';

export default {
    components: {},
    props: {},
    mixins: [services],
    data() {
        return {
            title: "",
            dialogVisible: false,
            KingdeeAddForm: this.getKingdeeAddData(), // 提交数据
            opts: {},
            ProjectTypes: MAP_LIST.INTENT_PROJECT
        }
    },
    methods: {
        // 还款、认款弹窗数据
        getKingdeeAddData() {
            return cloneDeep({
                AgentId: 0,
                OrderId: 0,
                ProjectType: 0,
                ParagraphAmount: null,
                ParagraphType: 1,
                Remark: ""
            });
        },
        show(options) {
            this.dialogVisible = true;
            this.form = options.data
            this.opts.title = options.title
            this.title = this.form.AccountTypeName + options.title
            this.KingdeeAddForm.AgentId = options.AgentId
            this.KingdeeAddForm.ProjectType = this.form.ProjectType
            this.KingdeeAddForm.ParagraphType = this.form.ParagraphType
        },
        // 确认还款
        KingdeeAdd() {
            // 判断金额
            let re = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/ 
            let nubmer = this.KingdeeAddForm.ParagraphAmount;
            if (!re.test(nubmer)) {　　　　
                this.$notify({
                    title: '提示',
                    message: '请输入正确金额格式',
                    type: 'warning'
                });　　　
                this.KingdeeAddForm.ParagraphAmount = null;　　　　
                return false;　　
            }
            if (nubmer <= 0) {
                this.$notify({
                    title: '提示',
                    message: '金额必须大于0',
                    type: 'warning'
                });
            } else if (this.KingdeeAddForm.Remark == '') {
                this.$notify({
                    title: '提示',
                    message: '请填写备注信息',
                    type: 'warning'
                });
            } else {
                this.Kingdee_ParagraphAdd(this.KingdeeAddForm)
            }

        },
        closeCallback() {
            this.dialogVisible = false;
            this.KingdeeAddForm = this.getKingdeeAddData()
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentAccountManage/components/returnMoney/vm.js